// extracted by mini-css-extract-plugin
module.exports = {"container":"detail_container_3Rklb"};